// extracted by mini-css-extract-plugin
export default {"wrapper":"root_wrapper"};